import GhostOutline from '@/images/GhostOutline.svg';
import styled from '@emotion/styled';
import { Button } from '@mui/material';

const ErrorStateContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 100px;
    min-height: 300px;
    gap: 16px;
    color: ${({ theme }) => theme.colors.black[600]};
`;

const ErrorMessage = styled.p`
    font-size: 16px;
    margin: 0;
    text-align: center;
`;

const StyledButton = styled(Button)`
    text-transform: none;
`;

const RetryButton = styled(StyledButton)``;

interface ErrorStateProps {
    onRetry: () => void;
}

export const ErrorState = ({ onRetry }: ErrorStateProps) => (
    <ErrorStateContainer>
        <img src={GhostOutline} alt="" width={32} height={32} />
        <ErrorMessage>We couldn't fetch templates. Check your connection and try again.</ErrorMessage>
        <RetryButton variant="text" color="secondary" onClick={onRetry} size="medium">
            Try again
        </RetryButton>
    </ErrorStateContainer>
);
